import useSubmitButtonName from 'hooks/forms/useSubmitButtonName';
import useSubmit from 'hooks/forms/useSubmitForm';
import { message } from 'antd';
import I18n from 'i18n-js';

const normalizeSelectValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value ?? null;
};

const buildFormParams = ({ form }) => {
  const rawValues = form.getFieldsValue();

  return {
    // eslint-disable-next-line camelcase
    ticket_comment: Object.fromEntries(
      Object.entries(rawValues).map(([key, value]) => {
        if (['author_id'].includes(key)) {
          return [key, normalizeSelectValue(value)];
        }

        return [key, value ?? null];
      }),
    ),
  };
};

const useSubmitForm = ({
  form,
  formUrl,
  clearErrors,
  handleError,
  setComments,
}) => {
  const { handleSubmitForm, isFormSending } = useSubmit({
    formUrl,
    handleError,
    objectId: null,
    beforeSubmitForm: clearErrors,
    buildFormParams: () => (buildFormParams({ form })),
    afterSuccessSubmitForm: ({ data }) => {
      form.resetFields();
      setComments((prev) => [...prev, data.comment]);
      message.success(I18n.t('flash.ticket_comments.created'));
    },
  });

  const handleSubmitWrapper = (formData) => {
    clearErrors();
    handleSubmitForm(formData);
  };

  const submitButtonName = useSubmitButtonName({
    objectId: null,
    isFormSending,
    modelName: 'ticket_comment',
  });

  return {
    isFormSending,
    submitButtonName,
    handleSubmitForm: handleSubmitWrapper,
  };
};

export default useSubmitForm;
